export default __webpack_public_path__ + "static/feature-importances-1bbc5ba8bf8d4d963d540b10f87fd13a.webp";